import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_COMPONENT_MACROS = registerFeatureWithDescription({
    numericalId: 403,
    id: "component-macros",
    name: "Component Library Macros",
    internalUseOnly: true,
    readyForProduction: false,
    descriptionLines: [
        "Allows inserting component library task elements as macro tokens in schedules.",
        "Component tokens use the format $cmp:taskId::element$ and resolve from the maintenance library.",
    ],
})
